import { Icon } from './Icon';

type Props = {
    balance: number;
    onBellClick: () => void;
    onPlusClick: () => void;
    onProfileClick: () => void;
    notifCount: number;
    /** When provided, renders a small shield icon button before the bell. */
    onAdminClick?: () => void;
};

export function Header({ balance, onBellClick, onPlusClick, onProfileClick, notifCount, onAdminClick }: Props) {
    return (
        <div className="header">
            <div
                className="balance-pill"
                role="button"
                aria-label="Баланс"
                onClick={onPlusClick}
            >
                <span className="balance-text">
                    <Icon name="star" size={14} filled color="var(--accent)" style={{ verticalAlign: '-2px', marginRight: 4 }} />
                    {balance.toLocaleString('ru-RU')} <small>BSP</small>
                </span>
                <button
                    type="button"
                    className="plus-btn"
                    aria-label="Пополнить"
                    onClick={(e) => {
                        e.stopPropagation();
                        onPlusClick();
                    }}
                >
                    <Icon name="plus" size={18} strokeWidth={2.5} />
                </button>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <button
                    type="button"
                    className="header-icon-btn"
                    aria-label="Профиль"
                    onClick={onProfileClick}
                >
                    <Icon name="profile" size={19} />
                </button>
                {onAdminClick && (
                    <button
                        type="button"
                        className="admin-shortcut"
                        aria-label="Админ-панель"
                        onClick={onAdminClick}
                    >
                        <Icon name="shield" size={18} color="var(--accent)" />
                    </button>
                )}
                <div
                    className="bell-container"
                    role="button"
                    aria-label="Уведомления"
                    onClick={onBellClick}
                >
                    <Icon name="bell" size={18} className="bell-icon" />
                    {notifCount > 0 && <div className="badge">{notifCount}</div>}
                </div>
            </div>
        </div>
    );
}
